import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { Carousel } from 'primeng/carousel';

@Directive({ selector: '[appSwipeScroll]' })
export class SwipeScrollDirective implements AfterViewInit, OnDestroy {
    private cleanupFns: Array<() => void> = [];

    constructor(private el: ElementRef) {
        Carousel.prototype.onTouchMove = () => {};
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const host = this.el.nativeElement as HTMLElement;
            const prime = host.querySelector('.p-carousel-items-content') as HTMLElement | null;
            const custom =
                (host.querySelector('.more-deals-scroller') as HTMLElement | null) ||
                (host.querySelector('.viator-scroller') as HTMLElement | null);
            const target = prime || custom;
            if (!target) {
                return;
            }
            this.setupDragToScroll(target);
        }, 0);
    }

    ngOnDestroy(): void {
        this.cleanupFns.forEach(fn => fn());
        this.cleanupFns = [];
    }

    private setupDragToScroll(scroller: HTMLElement) {
        let isDown = false;
        let startX = 0;
        let startY = 0;
        let scrollLeft = 0;
        let isDragging = false;

        scroller.style.cursor = 'grab';

        const onMouseDown = (e: MouseEvent) => {
            if (e.button !== 0) {
                return;
            }
            
            isDown = true;
            isDragging = false;
            startX = e.pageX - scroller.offsetLeft;
            startY = e.pageY - scroller.offsetTop;
            scrollLeft = scroller.scrollLeft;
            scroller.style.cursor = 'grabbing';
        };

        const onMouseLeave = () => {
            isDown = false;
            scroller.style.cursor = 'grab';
        };

        const onMouseUp = () => {
            isDown = false;
            scroller.style.cursor = 'grab';
            
            setTimeout(() => {
                isDragging = false;
            }, 10);
        };

        const onMouseMove = (e: MouseEvent) => {
            if (!isDown) return;
            
            e.preventDefault();
            
            const x = e.pageX - scroller.offsetLeft;
            const walk = x - startX;
            
            if (Math.abs(walk) > 3) {
                isDragging = true;
                scroller.scrollLeft = scrollLeft - walk;
            }
        };

        const preventClickIfDragging = (e: MouseEvent): boolean => {
            if (isDragging) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }
            return true;
        };

        const observer = new MutationObserver(() => {
            const clickableElements = scroller.querySelectorAll('.more-deals-item, .viator-item, deal-card, viator-card, a, button');
            clickableElements.forEach(el => {
                el.removeEventListener('click', preventClickIfDragging as EventListener, true);
                el.addEventListener('click', preventClickIfDragging as EventListener, true);
            });
        });

        observer.observe(scroller, { childList: true, subtree: true });
        
        const clickableElements = scroller.querySelectorAll('.more-deals-item, .viator-item, deal-card, viator-card, a, button');
        clickableElements.forEach(el => {
            el.addEventListener('click', preventClickIfDragging as EventListener, true);
        });

        scroller.addEventListener('mousedown', onMouseDown);
        scroller.addEventListener('mouseleave', onMouseLeave);
        scroller.addEventListener('mouseup', onMouseUp);
        scroller.addEventListener('mousemove', onMouseMove);

        this.cleanupFns.push(() => {
            observer.disconnect();
            scroller.removeEventListener('mousedown', onMouseDown);
            scroller.removeEventListener('mouseleave', onMouseLeave);
            scroller.removeEventListener('mouseup', onMouseUp);
            scroller.removeEventListener('mousemove', onMouseMove);
            
            const clickableElements = scroller.querySelectorAll('.more-deals-item, .viator-item, deal-card, viator-card, a, button');
            clickableElements.forEach(el => {
                el.removeEventListener('click', preventClickIfDragging as EventListener, true);
            });
        });
    }
}